module.exports = __webpack_public_path__ + "img/full6-min.de6f217e.png";